import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  HStack,
  Link,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";

import { useRef } from "react";
import { HamburgerIcon } from "@chakra-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { exportAllSearchResults } from "../store/search";
import { downloadSelected, unselectArticle } from "../store/export";
import { SearchBar } from "./Search";
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
import axios from "axios";
import { config } from "../config";
import { Filters } from "./filters";
import { Link as RouterLink } from "react-router-dom";

function FilterDrawer() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef();

  return (
    <>
      <Button
        ref={btnRef}
        onClick={onOpen}
        variant={"ghost"}
        colorScheme={"yellow"}
        leftIcon={<HamburgerIcon color={"yellow.200"} />}
        _hover={{ bg: "gray.700" }}
      >
        <Text color="yellow.200">Filters</Text>
      </Button>
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent bgColor={"gray.800"} overflow="scroll">
          <DrawerCloseButton color={"white"} />
          <DrawerHeader mb={10}>
            <Filters />
          </DrawerHeader>
          <Box p={2}></Box>
        </DrawerContent>
      </Drawer>
    </>
  );
}

function ExportSelectedModal() {
  const selectedArticles = useSelector((s) => s.selectSlice.selectedArticles);
  const titleIdMap = useSelector((s) => s.selectSlice.titleIdMap);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  const btnRef = useRef(null);
  return (
    <>
      <Button mr={2} colorScheme={"yellow"} ref={btnRef} onClick={onOpen}>
        Export Selected
      </Button>

      <Modal
        onClose={onClose}
        finalFocusRef={btnRef}
        isOpen={isOpen}
        size={"xl"}
        scrollBehavior={"inside"}
      >
        <ModalOverlay />
        <ModalContent bgColor={"gray.900"}>
          <ModalHeader color={"yellow.500"}>Selected Articles</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack alignItems="start" spacing={3}>
              {selectedArticles.map((st) => (
                <Box
                  color={"yellow.200"}
                  bgColor={"gray.800"}
                  border
                  borderRadius={"md"}
                  p={4}
                  borderWidth={1}
                  w={"100%"}
                >
                  <HStack>
                    <Checkbox
                      colorScheme={"yellow"}
                      onChange={() => dispatch(unselectArticle({ id: st }))}
                      isChecked={selectedArticles.includes(st)}
                    ></Checkbox>
                    <Box>{titleIdMap[st]}</Box>
                  </HStack>
                </Box>
              ))}
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme={"yellow"} onClick={onClose}>
              Close
            </Button>
            <Button
              onClick={(e) => dispatch(downloadSelected())}
              colorScheme={"yellow"}
              ml={2}
            >
              Download
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

const UserProfileMenu = () => {
  const idCookie = Cookies.get("__needle-id-token");
  let decodedToken = {};
  try {
    decodedToken = jwt_decode(idCookie);
  } catch (e) {
    console.error(e);
  }

  const reqLogout = () => {
    axios({
      method: "GET",
      url: config.LOGOUT_URL,
      withCredentials: true,
    })
      .then(() => {
        window.location.href = `${config.COGNITO_AUTH_BASE_URL}${config.COGNITO_AUTH_LOGOUT_ENDPOINT}?client_id=${config.COGNITO_CLIENT_ID}&logout_uri=${config.COGNITO_LOGOUT_CALLBACK}`;
      })
      .catch((e) => console.log(e));
  };
  return (
    <Box mr={2}>
      <Menu>
        <MenuButton>
          <Avatar size={"md"} name={decodedToken["cognito:username"]}></Avatar>
        </MenuButton>
        <MenuList>
          <MenuItem color={"red"} onClick={() => reqLogout()}>
            Logout
          </MenuItem>
        </MenuList>
      </Menu>
    </Box>
  );
};

const ExportAll = () => {
  const dispatch = useDispatch();
  return (
    <Button
      onClick={() => dispatch(exportAllSearchResults())}
      colorScheme={"yellow"}
      _hover={{ bg: "yellow.500" }}
      px={5}
    >
      Export All Search Hits
    </Button>
  );
};

const NavLink = ({ to, children, isActive }) => (
  <Button
    as={RouterLink}
    to={to}
    variant="ghost"
    size="sm"
    color={isActive ? "yellow.300" : "gray.300"}
    fontWeight={isActive ? "semibold" : "normal"}
    _hover={{ bg: "gray.700", color: "yellow.300" }}
    borderBottom={isActive ? "2px solid" : "none"}
    borderColor="yellow.400"
    borderRadius="none"
    px={4}
    py={5}
  >
    {children}
  </Button>
);

export const Navbar = () => {
  return (
    <Flex
      bgColor={"gray.900"}
      color={"yellow.500"}
      minWidth="max-content"
      alignItems="center"
      gap="2"
      py={2}
    >
      <Box p="2">
        <FilterDrawer />
      </Box>
      <HStack spacing={1} ml={4}>
        <NavLink to="/" isActive={true}>
          News Search
        </NavLink>
        <NavLink to="/reports" isActive={false}>
          43-101 Reports
        </NavLink>
      </HStack>
      <Spacer />
      <SearchBar />
      <ExportAll />
      <ExportSelectedModal />
      <UserProfileMenu />
    </Flex>
  );
};
